exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\n\nselect.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\n\n/*select.ng-invalid.ng-untouched{\n\tborder:1px solid red;\n\n}*/\nselect.ng-untouched{\n\tborder:1px solid #FF9000;\n}\n\ninput.ng-invalid {\n\tborder:1px solid #FF9000;\n}\n\n/*.product-field-border{\n\tborder:1px solid #FF9000;\n}*/\n\nlabel.font-size-17{\n\tfont-size: 17px;\n}\n.gatepassform_error_message\n{\n\tcolor: red;\n}\n\ntr {\n    cursor: pointer;\n}\n\nsmall{\n\tfont-size: 14px;\n\ttext-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/baba_frontend/src/app/gate-pass/gate-pass.component.css
// module id = ../../../../../src/app/gate-pass/gate-pass.component.css
// module chunks = main